<section class="wrap-consults">
  <div class="layout">
    <div class="top-area">
      <h3 class="subtitle">Consultas</h3>
      <p>A garantia de uma negociação mais segura, do cadastro do veiculo até a indicação de sinistralidade. A Union
        apresenta as soluções que a sua empresa precisa para buscar tudo que diz respeito a informações veiculares.</p>
      <figure appAppearRightOnScroll class="foto_mobile">
        <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Consulta-veicular.png" alt="Consultas">
      </figure>
    </div>

    <div class="box-area">
      <div class="list-topics">
        <div class="topic">Agregado Veicular</div>
        <div class="topic">Dados Estaduais&nbsp;</div>
        <div class="topic">Dados Nacionais&nbsp;</div>
        <div class="topic">Dados Judiciais Renajud&nbsp;</div>
        <div class="topic">VIN DECODE&nbsp;</div>
        <div class="topic">Gravame - Detalhes do Financiamento&nbsp;</div>
        <div class="topic">Histórico de Proprietários Anteriores (Base Histórica até julho de 2018)&nbsp;</div>
        <div class="topic">Histórico de Roubo e Furto&nbsp;</div>
        <div class="topic">Indício de Sinistro 1 e 2&nbsp;</div>
        <div class="topic">Veículos Ofertados a leilão&nbsp;</div>
        <div class="topic">Localizador de Chassi e Motor&nbsp;</div>
        <div class="topic">Localizador de Placa e Chassi</div>
        <div class="topic">Localizador de veículo</div>
        <div class="topic">Parecer técnico</div>
        <div class="topic">Histórico de venda</div>
        <div class="topic">Recall</div>
        <div class="topic">Precificador</div>
        <div class="topic">Cnh</div>
        <div class="topic">Cotação Seguro</div>
        <div class="topic">Leilão complementar</div>
        <div class="topic">Crlv-e</div>
        <div class="topic">Renavam</div>
        <div class="topic">CSV</div>
      </div>
      <figure appAppearRightOnScroll class="foto">
        <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Consulta-veicular.png" alt="Consultas">
      </figure>
    </div>
  </div>
</section>
